import TechnicalSanction from "./TechnicalSanction";
import GRPendingList from "./GRPendingList";
import TechnicalSanctionApprove from "./TechnicalSanctionInwards/TechnicalSanctionApprove";
import TechnicalSanctionInwards from "./TechnicalSanctionInwards/TechnicalSanctionInwards";
export {TechnicalSanction,GRPendingList,TechnicalSanctionInwards,TechnicalSanctionApprove}